import styled from 'styled-components';
import colors from '@theme/colors';
import media from '@theme/media';
import { FlexContainer } from '@layout';

export const TranscriptsList = styled.ul`
  padding: 0;
`;

export const CardWrapper = styled.li`
  list-style: none;
  background-color: ${colors.WHITE};
  padding: 30px;
  margin: 0 auto 5px auto;
  max-width: 1000px;
`;

export const CardHead = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
  h2 {
    font-size: 14px;
    font-weight: 700;
    color: ${colors.DARK_GREY};
  }
  div {
    color: ${colors.GREY};
    font-size: 12px;
    font-weight: 400;
    margin-left: 30px;
  }
  ${media.large} {
    margin: 0 30px 0 0;
    align-items: center;
    width: 100%;
    h2 {
      margin: 0;
      color: ${colors.DARK_GREY};
    }
  }
`;

export const ButtonsWrapper = styled(FlexContainer).attrs({
  inline: true,
})`
  justify-content: space-between;
`;

export const VisiblePart = styled.div`
  ${media.large} {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
`;

export const ArrowWrapper = styled.div`
  ${media.large} {
    padding-left: 30px;
  }
`;

export const Details = styled.div`
  &::before {
    content: '';
    display: inline-block;
    width: 100%;
    border: 1px solid ${colors.LIGHT_GREY};
    margin: 20px 0;
  }
  td {
    color: ${colors.GREY};
  }
`;

export const Tags = styled.div`
  margin-top: 20px;
`;



// WEBPACK FOOTER //
// ./components/layout/AttendeeDashboard.js